import type React from "react";

const isNodeIterable = (
  i: React.ReactNode | Iterable<React.ReactNode>,
): i is Iterable<React.ReactNode> => {
  return Symbol.iterator in (i as Iterable<React.ReactNode>);
};

export function reactNodeKey(
  node: React.ReactNode | (() => React.ReactNode),
): string {
  switch (typeof node) {
    case "object":
      if (!node) return String(node); // haha null is an object
      if (isNodeIterable(node))
        return Array.from(node).map(reactNodeKey).join();
      return node.key || node.props.key || node.type;
    case "function":
      return node.name;
    default:
      return String(node);
  }
}
